export class StageEmergeAnswer {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get emerge() {
        return this.parent;
    }
    get stage() {
        return this.emerge.stage;
    }
    get app() {
        return this.stage.app;
    }
}
